import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import {
	_capitalizeText,
	_formatNumber,
} from "../../../shared/helpers/utils";

const useStyles = makeStyles((theme) => ({
	filterContainer: {
		padding: "10px 15px 5px",
	},
	chips: {
		display: "flex",
		flexWrap: "wrap",
		marginLeft: 5,
	},
	chip: {
		margin: 3,
		marginLeft: 5,
	},
}));

const categories = [
	"all",
	"residential",
	"office-and-retail",
	"public-facilities",
	"vacant-land",
	"industrial-and-manufacturing",
	"transportation-and-utility",
	"parking-facilities",
	"open-space-and-outdoor-recreation",
	"mixed-use",
	"commercial",
	"unknown",
];

const getCategoryCount = (facetData, category) => {
	if (!facetData || !facetData.by_property_category || !facetData.by_property_category.buckets) {
		return null;
	}
	if (category === "all") {
		return null;
	}
	const bucket = facetData.by_property_category.buckets.find(
		(b) => b.val === category
	);
	return bucket ? bucket.count : 0;
};

export default function MatTableFiltersSelect(props) {
	const classes = useStyles();
	const { selectedCategory, setSelectedCategory, facetData } = props;

	return (
		<div className={classes.filterContainer}>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					padding: "10px 0",
					margin: "0 10px",
					borderBottom: "1px solid #DBE0E8",
				}}
			>
				<span className="label" style={{ fontWeight: 500, fontSize: 13, whiteSpace: "nowrap" }}>
					Property Category:
				</span>
				<div className={classes.chips} style={{ overflowX: "auto" }}>
					{categories.map((cat) => {
						const selected = selectedCategory === cat;
						const count = getCategoryCount(facetData, cat);
						const label = `${_capitalizeText(cat.replace(/-/g, " "))}${
							count !== null ? ` (${_formatNumber(count)})` : ""
						}`;
						return (
							<Chip
								key={cat}
								size="small"
								label={label}
								clickable
								onClick={() => setSelectedCategory(cat)}
								color={selected ? "primary" : "default"}
								className={classes.chip}
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
}
